import React, { useEffect, useState } from 'react';
import Input from '../../../../components/Input'
import PopupNewPassword from '../../../../components/PopupNewPassword';
import academyServices from '../../../../services/academy/academyServices';

import './styles.css';





export default function FormAcademy(props) {
    const [nome, setNome] = useState("");
    const [cidade, setCidade] = useState("");
    const [logradouro, setLogradouro] = useState("");
    const [numero, setNumero] = useState("");
    const [logo, setLogo] = useState("");
    const [idioma, setIdioma] = useState("");
    const [timezone, setTimezone] = useState("");
    const [ddi, setDdi] = useState("");
    const [iso2, setIso2] = useState("");
    const [telefone, setTelefone] = useState("");
    const [isValidNumber, setIsValidNumber] = useState('');
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");

    const [visibility, setVisibility] = useState(false);

    useEffect(() => {
        if(props.academy && Object.keys(props.academy).length > 0) {
            setNome(props.academy.nome);
            setCidade(props.academy.cidade);
            setIso2(props.academy.iso2_ddi);
            setDdi(props.academy.ddi);
            setTelefone(props.academy.telefone);
            setIdioma(academyServices.languages.find(obj => obj[0] ===props.academy.idioma)[1]);
            setTimezone(props.academy.timezone);
            setLogo(props.academy.logo ? props.academy.logo : "");
            setLogradouro(props.academy.logradouro);
            setNumero(props.academy.numero);
            setEmail(props.academy.user.email);
        }

    }, [props.academy]);

    function onClick (e) {
        e.preventDefault();
        if(!isValidNumber) {
            alert("Digite um telefone válido");
            return;
        }
        if(password != password2) {
            alert("Os campos de senha e confirmação de senha devem ser iguais.");
            return;
        }
        let idiomaValue, timezoneValue, logoValue;
        if(idioma){
            idiomaValue = academyServices.languages.find(obj => obj[1] === idioma)[0];
        }
        if(timezone) {
            timezoneValue = academyServices.timezones.find(obj => obj[1] === timezone)[0] 
        }
        console.log("timezone: ",timezoneValue);
        logoValue = props.academy ? (props.academy.logo !== logo ? logo : null) : logo;
        props.onClick({nome, cidade, logradouro, numero, ddi, iso2, telefone, logo: logoValue, idioma: idiomaValue, timezone: timezoneValue, email, password})
    }
    return (
        <form className='academy-form' action=''>
            <h4>{props.title}</h4>
            <Input
                label="Nome*"
                placeholder="Nome"
                id="academy-form-nome"
                onChange={(e) => setNome(e.target.value)}
                value={nome}
            />

            <Input
                label="Cidade*"
                placeholder="Cidade"
                id="academy-form-cidade"
                onChange={(e) => setCidade(e.target.value)}
                value={cidade}
            />
            <Input
                label="Logradouro*"
                placeholder="Logradouro"
                id="academy-form-logradouro"
                onChange={(e) => setLogradouro(e.target.value)}
                value={logradouro}
            />

            <Input
                label="Numero*"
                placeholder="Numero"
                type="number"
                id="academy-form-numero"
                onChange={(e) => setNumero(e.target.value)}
                value={numero}
            />

            <Input
                label='Logo'
                type='photo'
                accept="image/*"
                placeholder="Selecione uma foto"
                showFileLabel
                filePreview
                id='edit-student-form-photo'
                className='edit-student-form-photo'
                onChange={setLogo}
                value={logo ? (typeof logo === "string" ? logo : URL.createObjectURL(logo)) : ''}
            />

            <Input
                label="Idioma*"
                placeholder="Idioma"
                type="select"
                options={academyServices.languages.map(obj => obj[1])}
                id="academy-form-idioma"
                onChange={(e) => setIdioma(e.target.value)}
                value={idioma}
            />

            <Input
                label="Timezone*"
                placeholder="Timezone"
                type="select"
                options={academyServices.timezones.map(obj => obj[1])}
                id="academy-form-timezone"
                onChange={(e) => setTimezone(e.target.value)}
                value={timezone}
            />

            <Input
                label='Telefone*'
                type='tel'
                placeholder="Telefone"
                id='academy-form-phone'
                onChange={(event) => setTelefone(event.target.value)}
                iso2={iso2}
                setIso2={setIso2}
                setDialCode={setDdi}
                setIsValidNumber={setIsValidNumber}
                value={telefone}
            />

            <Input
                label="Email*"
                placeholder="Email"
                id="academy-form-email"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
            />
            {
                !props.edit ?
                <>
                    <Input
                        label="Senha*"
                        placeholder="Senha"
                        id="academy-form-senha"
                        onChange={(e) => setPassword(e.target.value)}
                        value={password}
                    />
        
                    <Input
                        label="Confirmação de Senha*"
                        placeholder="Confirmação de Senha"
                        id="academy-form-confirmacao-senha"
                        onChange={(e) => setPassword2(e.target.value)}
                        value={password2}
                    />
                </>
                :
                <>
                    <button className="academy-form-password-button" onClick={(e) => {
                        e.preventDefault();
                        setVisibility(true);
                        }}
                    >
                        Editar Senha
                    </button>
                    <PopupNewPassword
                        visibility={visibility}
                        setVisibility={setVisibility}
                        password={password}
                        confirmPassword={password2}
                        setPassword={setPassword}
                        setConfirmPassword={setPassword2}
                        onClick={() => setVisibility(false)}
                        buttonTitle="Fechar"
                    />
                </>


            }


            <button className="academy-form-submit-button" onClick={onClick}>
                {props.buttonTitle}
            </button>

        </form>
    )
}